import React from "react";

function Logo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="75"
      height="75"
      version="1"
      viewBox="0 0 375 375"
    >
      <defs>
        <clipPath id="id1">
          <path d="M70.059 113H98v25H70.059zm0 0"></path>
        </clipPath>
        <clipPath id="id2">
          <path d="M118 285h45v45.75h-45zm0 0"></path>
        </clipPath>
      </defs>
      <path
        fill="#A2574C"
        d="M177.414 200.566c2.887-1.527 26.906-11.421 26.906-11.421l8.285 22.515-35.19-11.094"
      ></path>
      <path
        fill="#7A3836"
        d="M203.02 191.195s-8.57 7.102-23.204 9.18c-14.636 2.082-36.136-12.621-36.136-12.621l59.34-4.774v8.215"
      ></path>
      <path
        fill="#A2574C"
        d="M207.285 181.645s4.895 5.12 15.121 10.812c10.23 5.691 19.274 8.664 19.274 8.664l-23.016 16.219-12.93-34.36 1.551-1.335"
      ></path>
      <path
        fill="#638ECC"
        d="M197.867 183.79s6.899 16.741 9.121 29.952c8.157 5.043 12.606 3.551 12.606 3.551s-5.934-20.926-14.531-35.477c-6.375-.89-7.196 1.973-7.196 1.973"
      ></path>
      <path
        fill="#4C76A8"
        d="M159.914 187.113v5.938l12.43 3.91-2.274-11.531-10.156 1.683"
      ></path>
      <path
        fill="#A2574C"
        d="M263.082 267.191s12.652 3.27 14.926 2.575c2.273-.692 4.445-7.72 11.566-9.106 7.113-1.387 15.219 3.664 13.043 13.66-2.172 10-5.336 23.66-11.562 26.133-6.227 2.477-40.723-2.078-40.723-2.078l12.75-31.184"
      ></path>
      <path
        fill="#95473F"
        d="M199.578 63.5c-1.398-12.188 7.336-23.203 19.508-24.602 12.168-1.402 23.168 7.348 24.566 19.536 1.395 12.187-7.336 23.203-19.507 24.601-12.172 1.403-23.172-7.344-24.567-19.535"
      ></path>
      <path
        fill="#702D2A"
        d="M209.672 63.535c-.684-5.972 3.594-11.37 9.562-12.058 5.965-.688 11.356 3.601 12.043 9.574.684 5.976-3.597 11.375-9.566 12.062-5.961.684-11.356-3.601-12.04-9.578"
      ></path>
      <path
        fill="#95473F"
        d="M135.71 70.844c-1.398-12.188-12.398-20.938-24.57-19.54C98.97 52.708 90.239 63.724 91.634 75.91c1.398 12.188 12.398 20.934 24.566 19.535 12.172-1.398 20.906-12.414 19.512-24.601"
      ></path>
      <path
        fill="#702D2A"
        d="M125.883 73.168c-.684-5.973-6.074-10.262-12.04-9.574-5.968.683-10.245 6.082-9.562 12.058.684 5.977 6.074 10.262 12.043 9.578 5.965-.687 10.246-6.09 9.559-12.062"
      ></path>
      <path
        fill="#95473F"
        d="M243.625 153.617c-7.844 10.567-18.988 22.906-62.871 27.953-43.879 5.047-57.527-4.445-67.559-12.957-5.136-4.36-8.172-10.898-9.46-17.562.316 8.574 3.437 18.02 10.167 23.73 10.032 8.512 23.68 18.004 67.559 12.961 43.883-5.047 55.031-17.39 62.871-27.953 5.266-7.094 6.168-17 4.535-25.422.25 6.781-1.222 13.84-5.242 19.25"
      ></path>
      <path
        fill="#A2574C"
        d="M180.758 181.57c43.879-5.047 55.027-17.386 62.87-27.953 4.017-5.414 5.49-12.469 5.24-19.25-.798-4.129-2.204-7.902-4.009-10.808-5.492-8.836-5.543-15.805-11.422-29.325-5.878-13.527-15.824-24.34-31.066-30.16-14.027-5.355-32.535-3.105-35.394-2.715-2.875.266-21.407 2.278-33.86 10.68-13.527 9.125-20.77 21.914-23.433 36.422-2.664 14.504-1.141 21.3-4.489 31.152-1.101 3.242-1.617 7.235-1.46 11.438 1.288 6.664 4.324 13.199 9.46 17.562 10.032 8.508 23.68 18 67.563 12.957"
      ></path>
      <path
        fill="#B66F5F"
        d="M207.297 134.93c-8.211 0-13.727-5.727-14.602-13.336-.945-8.25 3.93-15.586 13.313-16.668a20.978 20.978 0 012.316-.13c8.617 0 16.942 5.38 17.809 12.954 1.222 10.648-7.317 15.977-16.7 17.055-.73.086-1.44.125-2.136.125"
      ></path>
      <path
        fill="#231C1B"
        d="M205.184 125.445c.105 1.91 1.609 3.38 3.351 3.278 1.742-.098 3.07-1.727 2.965-3.637-.11-1.91-1.613-3.379-3.355-3.277-1.743.097-3.07 1.726-2.961 3.636"
      ></path>
      <path
        fill="#C76F66"
        d="M210.93 149.906c-4.172 0-7.653-2.394-8.032-5.726-.421-3.668 3.063-7.082 7.782-7.621.43-.051.851-.075 1.27-.075 4.175 0 7.652 2.399 8.034 5.73.418 3.665-3.066 7.079-7.78 7.618-.43.05-.856.074-1.274.074"
      ></path>
      <path
        fill="#823C36"
        d="M216.555 109.332s-4.008-1.691-8.293-1.613c-4.29.074-6.246-2.477-6.125-5.059.12-2.578 3.062-5.347 10.898-2.847 7.84 2.5 7.406 6.574 7.094 8.066-.313 1.496-2.106 1.976-3.574 1.453"
      ></path>
      <path
        fill="#B66F5F"
        d="M138.887 142.727c-8.184 0-15.696-3.645-16.77-13.02-.945-8.25 7.317-15.977 16.7-17.055.73-.086 1.44-.125 2.136-.125 8.211 0 13.73 5.73 14.602 13.336.945 8.25-3.93 15.586-13.313 16.668a29.442 29.442 0 01-3.355.196"
      ></path>
      <path
        fill="#F9DAD4"
        d="M197.734 148.809c1.27 11.105-6.687 21.144-17.777 22.418-11.09 1.273-21.113-6.696-22.387-17.801-1.273-11.11 6.684-21.145 17.774-22.422 11.09-1.274 21.113 6.695 22.39 17.805"
      ></path>
      <path
        fill="#231C1B"
        d="M177.414 149.047l1.64 14.308-.761.09-1.8-15.71.921 1.312"
      ></path>
      <path
        fill="#702D2A"
        d="M175.902 135.871l1.512 13.176s-11.254-.102-11.851-5.313c-.598-5.21 6.312-7.402 10.34-7.863"
      ></path>
      <path
        fill="#231C1B"
        d="M179.129 164.004c-11.508 1.32-16.024-7.02-17.086-9.461a.644.644 0 111.188-.5c.917 2.195 4.94 9.906 15.75 8.664l.148 1.297"
      ></path>
      <path
        fill="#231C1B"
        d="M177.414 149.047l1.64 14.308.758-.085-1.796-15.711-.602 1.488"
      ></path>
      <path
        fill="#702D2A"
        d="M175.902 135.867l1.512 13.18s10.938-2.652 10.34-7.867c-.598-5.211-7.824-5.774-11.852-5.313"
      ></path>
      <path
        fill="#231C1B"
        d="M179.129 164.004c11.504-1.324 14.016-10.473 14.5-13.09a.643.643 0 00-.578-.758.645.645 0 00-.696.54c-.394 2.347-2.57 10.769-13.375 12.011l.149 1.297M144.266 132.445c.328 1.887-.805 3.66-2.524 3.957-1.722.301-3.383-.988-3.71-2.87-.325-1.887.804-3.657 2.523-3.958 1.722-.297 3.382.988 3.71 2.871"
      ></path>
      <path
        fill="#C76F66"
        d="M141.676 157.871c-4.172 0-7.649-2.394-8.031-5.73-.422-3.668 3.062-7.078 7.78-7.621.427-.047.852-.075 1.27-.075 4.172 0 7.653 2.399 8.035 5.73.418 3.669-3.062 7.079-7.785 7.622-.425.05-.851.074-1.27.074"
      ></path>
      <path
        fill="#823C36"
        d="M129.543 119.336s3.52-2.555 7.71-3.453c4.196-.899 5.524-3.828 4.821-6.317-.699-2.484-4.191-4.515-11.262-.3-7.07 4.214-5.726 8.086-5.082 9.468.645 1.383 2.5 1.446 3.813.602"
      ></path>
      <path fill="#E8BCB1" d="M176.484 140.922l-.28-2.434.28 2.434"></path>
      <path
        fill="#88463E"
        d="M176.484 140.922c-.941-.203-1.558-.57-1.613-1.047-.055-.48.461-.98 1.332-1.387l.281 2.434M178.3 141.09a8.987 8.987 0 01-1.816-.168l-.28-2.434c.808-.379 1.921-.683 3.167-.824.504-.059.992-.086 1.45-.086 1.913 0 3.347.473 3.433 1.215.105.926-1.91 1.914-4.5 2.215-.504.054-.992.082-1.453.082"
      ></path>
      <path
        fill="#A2574C"
        d="M191.375 61.348s-14.273-.942-21.98-4.84c-7.711-3.895-9.602-9.953-5.786-14.88-8.074 1.626-16.246 8.446-8.398 20.497-4.899-2.824-6.723-5.703-7.328-10.117-2.11 5.023-.371 11.5 4.129 15.168 4.496 3.668 32.91 1.781 39.363-5.828"
      ></path>
      <path
        fill="#95473F"
        d="M149.676 64.703s7.172 8.992 26.258 1.516c-11.368 6.785-25.645 5.297-29.672-.446 1.734-.566 3.414-1.07 3.414-1.07M270.07 268.82v31.668l-23.347-1.32 18.203-31.516 5.144 1.168"
      ></path>
      <path
        fill="#FAB535"
        d="M128.617 156.98c-17.492 0-31.668-14.199-31.668-31.714 0-17.516 14.176-31.715 31.668-31.715 17.488 0 31.668 14.199 31.668 31.715 0 17.515-14.18 31.714-31.668 31.714zm0-66.597c-19.238 0-34.832 15.617-34.832 34.883 0 19.265 15.594 34.882 34.832 34.882s34.832-15.617 34.832-34.882c0-19.266-15.594-34.883-34.832-34.883M214.648 141.254c-17.492 0-31.671-14.203-31.671-31.719 0-17.515 14.18-31.715 31.671-31.715 17.489 0 31.665 14.2 31.665 31.715 0 17.516-14.176 31.719-31.665 31.719zm0-66.602c-19.238 0-34.835 15.621-34.835 34.883 0 19.266 15.597 34.887 34.835 34.887 19.235 0 34.829-15.621 34.829-34.887 0-19.262-15.594-34.883-34.829-34.883"
      ></path>
      <path
        fill="#FAB535"
        d="M162.797 128.742s3.117.723 3.785-.949c.668-1.672-.523-7.309 6.031-8.313 6.559-1.003 6.922 5.356 8.465 5.805 1.547.445 3.227-1.453 3.227-1.453l-1.235-1.562s-1.53.84-1.906.78c-.379-.054-2.144-6.972-9.582-5.167-7.437 1.8-6.281 8.797-6.45 9.133-.167.332-2.675-.059-2.675-.059l.34 1.785"
      ></path>
      <g clipPath="url(#id1)">
        <path
          fill="#FAB535"
          d="M96.95 137.047a.815.815 0 01-.665-.34c-.133-.187-13.402-18.668-18.687-21.223-1.25-.601-2.274-.605-3.121-.011-1.95 1.363-2.809 5.746-2.489 9.023.301 3.063 1.461 5.672 2.887 6.496.613.356 1.258.367 1.973.043 2.593-1.18 1.629-6.09 1.617-6.14a.813.813 0 011.59-.34c.054.254 1.277 6.23-2.535 7.965-1.192.542-2.387.5-3.457-.118-2.293-1.324-3.41-4.87-3.692-7.746-.297-3 .305-8.511 3.172-10.52.934-.652 2.516-1.198 4.762-.116 5.656 2.73 18.75 20.964 19.304 21.738a.817.817 0 01-.66 1.289"
        ></path>
      </g>
      <path
        fill="#FAB535"
        d="M247.867 107.656a.805.805 0 00.446-.597c.039-.227 3.832-22.672 7.457-27.293.855-1.094 1.773-1.547 2.796-1.387 2.352.363 5.051 3.922 6.2 7.004 1.074 2.883 1.18 5.738.261 7.105-.394.59-.968.887-1.75.91-2.847.082-4.14-4.753-4.152-4.804a.813.813 0 10-1.578.398c.062.25 1.59 6.156 5.777 6.031 1.309-.035 2.363-.601 3.055-1.625 1.476-2.199.922-5.878-.09-8.585-1.055-2.825-4.016-7.508-7.473-8.043-1.125-.176-2.789.027-4.324 1.988-3.883 4.945-7.625 27.09-7.781 28.031a.814.814 0 001.156.867"
      ></path>
      <path
        fill="#F14726"
        d="M229.34 222.82l49.703-25.86-19.719 98.743-44.922 26.578 14.938-99.46"
      ></path>
      <path
        fill="#E33E20"
        d="M229.34 222.82l-18.645 1.461-14.828 98.742 18.535-.742 14.938-99.46"
      ></path>
      <path
        fill="#BC3322"
        d="M210.695 224.281l-84.511-31.824-17.051 99.383 86.734 31.183 14.828-98.742"
      ></path>
      <g clipPath="url(#id2)">
        <path
          fill="#A2574C"
          d="M131.984 300.055s-.265-13.856 13.278-14.547c13.543-.695 16.21 9.797 17 21.082.793 11.285-2.305 22.965-15.14 23.558-12.833.594-29.856-13.828-28.313-34.828a47684.6 47684.6 0 0013.175 4.735"
        ></path>
      </g>
      <path
        fill="#3C1E1E"
        d="M155.54 304.215s1.683 10.394-.888 16.629c-2.57 6.238-10.18 4.851-12.16-2.473-1.976-7.324-1.976-16.828 4.055-18.61 6.031-1.78 8.203 1.977 8.992 4.454M141.852 295.98c-.446-1.277-1.747-1.984-2.907-1.578-1.16.407-1.738 1.77-1.293 3.047.446 1.278 1.75 1.985 2.91 1.578 1.157-.406 1.735-1.77 1.29-3.047M149.973 293.68c-.141-1.348-1.243-2.336-2.465-2.207-1.223.125-2.098 1.32-1.957 2.668.14 1.343 1.242 2.332 2.465 2.207 1.218-.13 2.097-1.325 1.957-2.668M157.668 296.934c.352-1.309-.328-2.625-1.516-2.946-1.183-.316-2.43.485-2.777 1.79-.352 1.308.324 2.624 1.512 2.945 1.187.32 2.43-.485 2.781-1.79"
      ></path>
      <path
        fill="#95473F"
        d="M131.984 300.055s-4.168.175-7.058 4.777c-2.89 4.606-.903 11.398-.903 11.398s-6.878-8.449-5.214-20.91l13.175 4.735"
      ></path>
      <path
        fill="#90271F"
        d="M131.512 234.86s4.457 13.277-3.844 22.882c-8.305 9.598-14.168 8.645-14.168 8.645l1.094-6.371 16.918-25.157"
      ></path>
      <path
        fill="#A2574C"
        d="M130.188 230.816c-2.817-6.308-5.977-7.77-9.223-7.933.867-4.508 2.047-12.848 3.16-18.426-11.71 1.484-26.11 18.191-24.926 36.211 1.188 18.02 13.938 21.922 21.797 17.914 7.86-4.008 14.23-16.48 9.192-27.766"
      ></path>
      <path
        fill="#9A251F"
        d="M126.184 192.457s1.113-2.18 3.261-1.805c2.153.371 80.754 30.758 80.754 30.758l18.387-1.234s44.035-22.918 46.898-24.254c2.868-1.336 3.559 1.039 3.559 1.039l-49.703 25.86-18.645 1.46-84.511-31.824"
      ></path>
      <path
        fill="#A2574C"
        d="M275.93 213.96s5.191 1.044 6.078 9.876c.89 8.836-4.149 19.004-10.153 22.05-6.007 3.044-10.23-1.261-10.675-7.796-.446-6.531 1.925-14.774 5.484-19.45 3.559-4.68 6.895-5.343 9.266-4.68"
      ></path>
      <path
        fill="#F6E1E0"
        d="M131.586 191.367l5.867-7.578s13.246 5.899 26.984 8.668c13.739 2.773 45.27 10.098 54.067 23.262 11.07-15.637 18.98-18.313 32.32-21.778 13.348-3.464 19.399-4.793 19.399-4.793l4.234 7.282-45.871 23.746-18.387 1.234-78.613-30.043"
      ></path>
      <path
        fill="#D0B2B3"
        d="M210.883 220.941l17.418-1.113s-3.297-2.933-9.637-2.488c-6.336.445-7.781 3.601-7.781 3.601"
      ></path>
      <path
        fill="#4C76A8"
        d="M201.277 192.457s5.086-3.062 6.149-6.367c-.637-1.207-1.43-2.645-1.43-2.645l-7.586 1.7 2.867 7.312"
      ></path>
    </svg>
  );
}

export default Logo;
